import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { ChromeMeta, resolveChrome } from '@Constants/ChromeConfig'

/** Resolves the chrome (header/footer) meta for the current route. */
export const useRouteChrome = (): ChromeMeta => {
	const { pathname } = useLocation()
	return useMemo(() => resolveChrome(pathname), [pathname])
}
